export default {
  locale: "es",
  name: "Propiedades",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [],
    form: [],
  },
};
